import { get } from "react-hook-form";
import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    OPPORTUNITY_BY_TEAM: "api/CRM/Report/Opportunities/Team",
    EXPORT_OPPORTUNITY_BY_TEAM: "api/CRM/Report/Opportunities/Team/Export",
    OPPORTUNITY_BY_STATUS: "api/CRM/Report/Opportunities/Status",
    TEAM_PERFORMANCE: "api/CRM/TeamPerformance",
    CUSTOMER_DETAILS: "api/CRM/TeamPerformance/CustomerDetails",
    OPPORTUNITY_DETAILS: "api/CRM/TeamPerformance/OpportunitiesDetails",
}

const getOpportunitiesByTeam = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.OPPORTUNITY_BY_TEAM, { params: payload });
    return res.data;
}

const exportOpportunitiesByTeam = async (payload: any) => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.EXPORT_OPPORTUNITY_BY_TEAM, { params: payload, responseType: "arraybuffer" });
    return res;
}

const getOpportunityByStatus = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.OPPORTUNITY_BY_STATUS, { params: payload });
    return res.data;
}

const getTeamPerformance = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.TEAM_PERFORMANCE, { params: payload });
    return res.data;
}

const getCustomerDetails = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.CUSTOMER_DETAILS, payload);
    return res.data;
}

const getOpportunityDetails = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.OPPORTUNITY_DETAILS, payload);
    return res.data;
}

const OpportunityReportService = {
    getOpportunitiesByTeam,
    exportOpportunitiesByTeam,
    getOpportunityByStatus,
    getTeamPerformance,
    getCustomerDetails,
    getOpportunityDetails,
};

export default OpportunityReportService;